import { AGENT, VISITOR } from 'conversations-message-history/constants/messageUses';
// @ts-expect-error untyped
import { isFromVisitor } from 'conversations-message-history/common-message-format/operators/senderTypeComparators';
import { getFirstName } from 'conversations-message-history/senders/operators/getters';
// @ts-expect-error untyped
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { TYPING_MESSAGE_STYLE } from 'conversations-message-history/typing-indicator/records/TypingIndicatorMessage';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import getIn from 'transmute/getIn';
import { announce } from 'visitor-ui-component-library/utils/aria-live/AriaLiveAnnouncer';
import GeneratingIndicator from '../atoms/GeneratingIndicator';
// @ts-expect-error untyped
import { getSenderFromMessageSenders } from '../common-message/operators/getSenderFromMessageSenders';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageAvatar from '../primary-message/components/PrimaryMessageAvatar';
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PrimaryMessageHeader from '../primary-message/components/PrimaryMessageHeader';
import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import SenderAvatar from '../sender-avatar/SenderAvatar';
import TypingHeaderContent from './TypingHeaderContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getTypingMessage = (style, isResponderAI) => {
  if (style === TYPING_MESSAGE_STYLE.STILL_THINKING) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.stillThinkingMessage"
    });
  } else if (isResponderAI || style === TYPING_MESSAGE_STYLE.THINKING) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.thinkingMessage"
    });
  } else {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-visitor-message-history.typingMessage"
    });
  }
};
const TypingIndicatorMessage = ({
  message,
  senders,
  style = TYPING_MESSAGE_STYLE.TYPING
}) => {
  const sender = getSenderFromMessageSenders(message, senders);
  const senderId = String(getIn(['id'], sender));

  // TODO: [GK] There has to be a better way to identify if the sender is an AI
  const isResponderAI = useSelector(state => {
    var _state$responders;
    return state === null || state === void 0 || (_state$responders = state.responders) === null || _state$responders === void 0 || (_state$responders = _state$responders.get('entries')) === null || _state$responders === void 0 || (_state$responders = _state$responders.find(a => a.getIn(['data', 'userId']) === parseInt(senderId, 10))) === null || _state$responders === void 0 ? void 0 : _state$responders.getIn(['data', 'isResponderAI']);
  });
  const isLoading = isSenderLoading(sender);
  const senderName = getFirstName(sender);
  const isVisitor = isFromVisitor(message);
  const use = isVisitor ? VISITOR : AGENT;
  useEffect(() => {
    if (!isVisitor) {
      announce(I18n.text('conversations-visitor-message-history.subjectIsTyping', {
        subject: senderName || I18n.text('conversations-visitor-message-history.agent')
      }));
    }
  }, [isVisitor, senderName]);
  return /*#__PURE__*/_jsxs(PrimaryMessage, {
    use: use,
    children: [/*#__PURE__*/_jsxs(PrimaryMessageHeader, {
      children: [/*#__PURE__*/_jsx(PrimaryMessageAvatar, {
        children: /*#__PURE__*/_jsx(SenderAvatar, {
          sender: sender,
          isLoading: isLoading
        })
      }), /*#__PURE__*/_jsx(PrimaryMessageHeaderContent, {
        children: /*#__PURE__*/_jsx(TypingHeaderContent, {
          sender: sender,
          isSenderLoading: isLoading
        })
      })]
    }), /*#__PURE__*/_jsx(PrimaryMessageContent, {
      style: {
        backgroundColor: 'transparent'
      },
      children: /*#__PURE__*/_jsx(GeneratingIndicator, {
        children: getTypingMessage(style, isResponderAI)
      })
    })]
  });
};
TypingIndicatorMessage.displayName = 'TypingIndicatorMessage';
export default TypingIndicatorMessage;